export default {
  isDevelopment: process.env.NODE_ENV === 'development',
  appBaseUrl: process.env.VUE_APP_BASE_URL || ''
}
